
import { useMemo } from "react";
import type { Candidate } from "@/components/candidates/types";
import type { Job as MainJobType } from "@/components/jobs/types"; // MainJobType is used for the prop

// Import new components
import { RecruiterPerformanceOverviewChart } from "./recruiter-performance/RecruiterPerformanceOverviewChart";
import { PerformanceMetricsComparisonChart } from "./recruiter-performance/PerformanceMetricsComparisonChart";
import { RecruiterEfficiencyScoreChart } from "./recruiter-performance/RecruiterEfficiencyScoreChart";

// Import types and utils
import { recruiters as mockRecruiters } from "./recruiter-performance/utils/mockData";
import { 
  calculatePerformanceData, 
  calculateRadarData 
} from "./recruiter-performance/utils/performanceCalculations";
import type { Recruiter, PerformanceData, RadarDataPoint } from "./recruiter-performance/types";

export interface RecruiterPerformanceProps {
  candidates: Candidate[];
  jobs: MainJobType[]; // This prop is part of the interface, kept for consistency
}

export const RecruiterPerformance = ({ candidates, jobs }: RecruiterPerformanceProps) => {
  const recruiters: Recruiter[] = useMemo(() => mockRecruiters, []);
  
  const performanceData: PerformanceData[] = useMemo(() => {
    return calculatePerformanceData(candidates, recruiters);
  }, [candidates, recruiters]);
  
  const radarData: RadarDataPoint[] = useMemo(() => {
    return calculateRadarData(performanceData, recruiters, candidates.length);
  }, [performanceData, recruiters, candidates.length]);

  return (
    <div className="space-y-6">
      <RecruiterPerformanceOverviewChart data={performanceData} />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <PerformanceMetricsComparisonChart data={radarData} />
        <RecruiterEfficiencyScoreChart data={performanceData} />
      </div>
    </div>
  );
};
